module.exports = __webpack_public_path__ + "exo-latin-700italic.dfd1344ebc20ecda89bf.eot";


//////////////////
// WEBPACK FOOTER
// /srv/prod/FitRadioAdmin2/node_modules/typeface-exo/files/exo-latin-700italic.eot
// module id = ../../../../typeface-exo/files/exo-latin-700italic.eot
// module chunks = styles